<script setup lang="ts">
import {ref, watch} from "vue";
import {getAdminGroups} from "@/Services/groups";
import {storeGroupMembers} from "@/Services/group-members";
import {saving} from "@/Composables/api";
import {Button, Dialog, Label, Select} from "@/Components/Library";
import {useMainStore} from "@/Stores/store";

const $store = useMainStore();
const bag = "contacts-group-invite";

const model = defineModel<boolean>("visible");
const props = defineProps<{
    currentContact?: {
        id: string;
        name: string;
        groups?: any[];
    };
}>();

const groups = ref();
const selectedGroup = ref(null);
const getGroups = async () => {
    try {
        let {data} = await getAdminGroups();
        if (props.currentContact?.groups?.length) {
            data = data.filter((group) => !props.currentContact?.groups.find((t) => t.id === group.id));
        }
        groups.value = data;
    } catch (e) {
        console.log(e);
    }
};
const save = async () => {
    try {
        let formData = {
            contacts: [props.currentContact.id],
        };

        await storeGroupMembers(selectedGroup.value.id, formData);

        setTimeout(() => {
            model.value = false;
        }, 2000);
    } catch (e) {
        console.log(e);
    } finally {
        selectedGroup.value = null;
    }
};

watch(
    () => model.value,
    (visible) => {
        if (visible) {
            getGroups();
        }
    },
);
</script>
<template>
    <Dialog
        v-model:visible="model"
        modal
        :header="`Add ${currentContact?.name} to a group`"
        class="mx-8 max-h-dvh w-full overflow-y-auto sm:max-w-sm"
    >
        <form class="flex flex-col gap-4" @submit.prevent="save">
            <div class="flex flex-col">
                <div v-if="currentContact?.groups?.length" class="mb-6">
                    <span class="mb-1 inline-block text-sm">Already part of these groups:</span>
                    <div class="flex flex-col gap-2">
                        <template v-for="(group, i) in currentContact.groups" :key="i">
                            <div class="rounded-lg p-4 text-white" :class="[`bg-${group.color?.class}`]">
                                {{ group.name }}
                            </div>
                        </template>
                    </div>
                </div>
                <Label for="group" class="mb-1" required>Select a group</Label>
                <Select
                    input-id="group"
                    name="group"
                    v-model="selectedGroup"
                    :options="groups"
                    optionLabel="name"
                    placeholder="Select a group"
                    fluid
                    required
                />
            </div>
            <Button :loading="saving" class="bg-askr-green text-white hover:brightness-110" type="submit">Add</Button>
        </form>
    </Dialog>
</template>
<style scoped></style>
